export const ACH = 'ACH';
export const ECHECK = 'eCheck';

export const reimbursementMethods = [
  { id: ACH, name: 'ACH' },
  { id: ECHECK, name: 'eCheck' },
];

export const REIMBURSEMENT_MODES_WITHOUT_CHECKS = ['ACH', 'RTP', 'CARE_CREDIT'];

export const reimbursementMethodsWithoutACH = [{ id: ECHECK, name: 'eCheck' }];
